import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import {ANALAGOUSCOLOR1} from "../../helpers/ThemeSettings";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: ANALAGOUSCOLOR1,
    color: 'white',
  },
  '&.MuiTableCell-body': {
    fontSize: 14,
  },
}));

const transparentGray = '#f2f2f2';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: transparentGray,
  },
}));

const stickyColumn = {
    position: 'sticky',
    left: 0,
    zIndex: 2,
    borderRight: '3px solid darkgray'
  };

const WW2DeathsTable = () => {
  const data = [
    {
      country: 'Soviet Union',
      militaryDeaths: 10700000,
      civilianDeaths: 11400000,
      totalDeaths: 22100000,
      population: 168500000,
      percentage: 13.12,
    },
    {
      country: 'China',
      militaryDeaths: 3000000,
      civilianDeaths: 14000000,
      totalDeaths: 17000000,
      population: 530000000,
      percentage: 3.21,
    },
    {
      country: 'Germany',
      militaryDeaths: 5533000,
      civilianDeaths: 2000000,
      totalDeaths: 7533000,
      population: 69850000,
      percentage: 10.79,
    },
    {
      country: 'Poland',
      militaryDeaths: 240000,
      civilianDeaths: 5750000,
      totalDeaths: 5990000,
      population: 34849000,
      percentage: 17.19,
    },
    {
      country: 'Japan',
      militaryDeaths: 2120000,
      civilianDeaths: 550000,
      totalDeaths: 2670000,
      population: 71380000,
      percentage: 3.74,
    },
    {
      country: 'United States',
      militaryDeaths: 418500,
      civilianDeaths: 12100,
      totalDeaths: 430600,
      population: 131028000,
      percentage: 0.33,
    },
    {
      country: 'British Empire',
      militaryDeaths: 855000,
      civilianDeaths: 2645000,
      totalDeaths: 3500000,
      population: 445536000,
      percentage: 0.79,
    },
    {
      country: 'Others',
      militaryDeaths: 1701000,
      civilianDeaths: 1492000,
      totalDeaths: 3193000,
      population: null,
      percentage: null,
    },
  ];

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(0) + 'K';
    }
    return num.toString();
  };

  return (<>
      <Typography style={{fontWeight: 'bold', paddingBottom: "8px"}}>WW2 Deaths by Country</Typography>
    <TableContainer component={Paper}>
      <Table aria-label="WW2 deaths table">
        <TableHead>
          <TableRow>
            <StyledTableCell style={stickyColumn} >Country</StyledTableCell>
            <StyledTableCell>Military Deaths</StyledTableCell>
            <StyledTableCell>Civilian Deaths</StyledTableCell>
            <StyledTableCell>Total Deaths</StyledTableCell>
            <StyledTableCell>Population (1940s)</StyledTableCell>
            <StyledTableCell>Deaths as % of Population</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <StyledTableRow key={index} >
              <StyledTableCell style={{...stickyColumn, backgroundColor: index % 2 === 0 ? transparentGray : 'white'}}>{row.country}</StyledTableCell>
              <StyledTableCell>{formatNumber(row.militaryDeaths)}</StyledTableCell>
              <StyledTableCell>{formatNumber(row.civilianDeaths)}</StyledTableCell>
              <StyledTableCell>{formatNumber(row.totalDeaths)}</StyledTableCell>
              <StyledTableCell>{row.population ? formatNumber(row.population) : '-'}</StyledTableCell>
              <StyledTableCell>{row.percentage ? `${row.percentage.toFixed(2)}%` : '-'}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};

export default WW2DeathsTable;
